import * as THREE from 'three'
import gsap from 'gsap'
import Experience from '../index'
import Environment from './Environment'
import Point from './Point'

let points = new Array()
let sceneReady = false

export default class World {
  constructor() {
    this.experience = new Experience()
    this.canvas = this.experience.canvas
    this.app = this.experience.app
    this.popUp = this.experience.popUp
    this.closeButton = this.experience.closeButton
    this.sizes = this.experience.sizes
    this.scene = this.experience.scene
    this.camera = this.experience.camera
    this.resources = this.experience.resources
    this.environment = new Environment()
    this.tl = gsap.timeline()
    this.raycaster = new THREE.Raycaster()
    this.group = new THREE.Group()
    this.scene.add(this.group)
    this.group.position.set(0, -3, 0)

    this.closeButton.forEach((button) => {
      button.addEventListener('click', this.closeButtonClicked)
    })
    this.createIntro()
    this.camera.orbitControls.enabled = false
  }

  createIntro() {
    this.resources.on('ready', () => {
      this.createPoints()
      this.createSphere()

      this.intro = document.querySelector('[data-name="globe-intro"]')
      gsap.set(this.intro, { autoAlpha: 0, translateY: '-10%' })

      this.tl
        .to(
          this.intro,
          {
            duration: 0.5,
            translateY: '0%',
            autoAlpha: 1,
            ease: 'expo.inOut',
          },
          0
        )
        .to(this.intro, {
          duration: 0.55,
          delay: 0.2,
          autoAlpha: 0,
          ease: 'power2.inOut',
        })
        .to(
          this.group.position,
          {
            duration: 1.5,
            y: 0,
            ease: 'expo.inOut',
            onComplete: () => {
              this.camera.orbitControls.enabled = true
            },
          },
          '<'
        )
    })
  }

  createSphere() {
    const geometry = new THREE.SphereGeometry(1, 64, 64)
    const material = new THREE.MeshStandardMaterial({
      roughness: 0.6,
      map: this.resources.items.earth,
      bumpMap: this.resources.items.earthBump,
      bumpScale: 0.1,
    })

    this.resources.items.earth.colorSpace = THREE.SRGBColorSpace
    this.resources.items.earthBump.magFilter = THREE.LinearFilter

    this.globe = new THREE.Mesh(geometry, material)
    this.globe.name = 'earth'

    this.globe.rotation.y = -Math.PI / 2

    this.group.add(this.globe)

    this.tl.to(this.group.position, {
      duration: 2.5,
      y: -2,
      ease: 'expo.inOut',
      onComplete: () => {
        sceneReady = true
        this.camera.orbitControls.autoRotate = true
      },
    })
  }

  createPoints() {
    // Create points with coordinates (latitude and longitude)
    // const point1 = new Point(37.7394, -25.6687, 'alumni')
    // const point2 = new Point(39.9042, 116.4074, 'events')
    // const point3 = new Point(34.0549, -118.2426, 'events')
    // const point4 = new Point(51.5074, -0.1278, 'pupil')
    // const point5 = new Point(26.8206, 30.8025, 'alumni')

    // console.info(communityPins);
    communityPins.forEach(pin => {
      const point = new Point(parseFloat((pin.lat).toFixed(4)), parseFloat((pin.lon).toFixed(4)), pin.type, pin.id)
      points.push(point)
      this.group.add(point.pinTo3d)
    });

    // points.push(point1, point2, point3, point4, point5)

    // Add points to group
    // this.group.add(
    //   point1.pinTo3d,
    //   point2.pinTo3d,
    //   point3.pinTo3d,
    //   point4.pinTo3d,
    //   point5.pinTo3d
    // )

    // Bind the point click function
    this.bindPointClicked = this.pointClicked.bind(this)

    // Listen for pin point clicks
    if (points.length > 0) {
      for (const point of points) {
        point.element.addEventListener('click', (event) => {
          this.bindPointClicked(event, point)
        })
      }
    }
  }

  pointClicked(event, point) {
    // When point is clicked
    event.stopPropagation()
    if(this.activePin) this.closeButtonClicked()

    this.activePin = point

    // Disable Camera Movement
    this.camera.orbitControls.enabled = false
    this.camera.orbitControls.autoRotate = false

    console.info(point)

    var globeTranslate;
    var globeDuration;
    var popupTranslate;
    if(window.innerWidth < 1024) {
      globeTranslate = '0%';
      globeDuration = 0;
      popupTranslate = '50%'
    } else {
      globeTranslate = '-25%';
      globeDuration = 0.75;
      popupTranslate = '-15%'
    }

    // Add and remove class on new clicked point
    for (const pin of points) {
      pin.element.classList.remove('clicked')
      point.element.classList.add('clicked')
    }

    this.tl
      .to(this.camera.camera.position, {
        duration: 1,
        x: point.position.x * 5,
        y: point.position.y * 5,
        z: point.position.z * 5,
        ease: 'expo.inOut',
      })
      .to(
        this.app,
        {
          translateX: globeTranslate,
          duration: globeDuration,
          ease: 'expo.inOut',
        },
        '-=0.85'
      )
      .to(
        '[data-name="pin-pop-up-' + point.id + '"]',
        {
          duration: 0.5,
          autoAlpha: 1,
          translateX: popupTranslate,
          ease: 'expo.out',
          zIndex: 20
        },
        '>'
      )

     
  }

  closeButtonClicked = () => {
    // Deactivate the click on the button, remove the class from the pin and disable re-enable the Camera Movement
    this.activePin.element.classList.remove('clicked')
    console.info(this.activePin)

    //Reactivate camera movement
    this.camera.orbitControls.enabled = true
    this.camera.orbitControls.autoRotate = true

    // this.closeButton.removeEventListener('click', this.closeButtonClicked)
    var pinDuration;
    var globeDuration;
    if(window.innerWidth < 1024) {
      pinDuration = 0.2;
      globeDuration = 0.1;
    } else {
      pinDuration = 1;
      globeDuration = 0;
    }


    this.tl
      .to('[data-name="pin-pop-up-' + this.activePin.id + '"]', {
        duration: pinDuration,
        autoAlpha: 0,
        translateX: '75%',
        ease: 'power2.inOut',
        zIndex: -1,
      })
      .to(
        this.app,
        {
          translateX: '0',
          duration: globeDuration,
          ease: 'expo.inOut',
        },
        '-=1'
      )
  }

  update() {
    if (sceneReady) {
      for (const point of points) {
        // Get point position relative to world and raycaster origin
        const screenPos = point.pinTo3d.getWorldPosition(
          this.raycaster.ray.origin
        )

        // Set a raycast direction based on the camera and the ray origin
        let rayDirection = this.camera.camera.position
          .clone()
          .sub(this.raycaster.ray.origin)
          .normalize()

        this.raycaster.ray.direction.set(
          rayDirection.x,
          rayDirection.y,
          rayDirection.z
        )

        // Select objects to raycast

        const intersects = this.raycaster.intersectObjects(this.group.children)

        // Hide and show points accordingly
        if (intersects.length === 0) {
          point.element.classList.add('visible')
        } else {
          // Calculates distance from raycaster to earth plus the earth's radius
          const intersectionDistance = intersects[0].distance + 1

          // Calculates distance from raycaster to points
          const pointDistance = screenPos.distanceTo(
            this.camera.camera.position
          )

          // If raycaster is intersecting with earth...
          if (intersects[0].object.name === 'earth') {
            // ... and if distance from raycaster to earth is smaller than distance from raycaster to points...
            if (intersectionDistance < pointDistance) {
              //... remove visible class from invisible points
              point.element.classList.remove('visible')
            } else {
              //... add visible class to visible points
              point.element.classList.add('visible')
            }
          }
        }
      }
    }
  }

  addEventListeners() {
    // clickPoints()
  }
}
